import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { AlmacenService } from '../../../core/services/almacen.service';
import { ContenedorDetail, InventoryIdenty, ResponseAddRelacionContenidoUnidadDocumental, ShoppingCart, TypeShoppingCart } from '../../../core/model/inventories';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { SeriesService } from '../../../core/services/series.service';
import { BsModalService } from 'ngx-bootstrap';
import { ModalShowTextComponent } from '../../../utils/modal-show-text/modal-show-text.component';
import { ShoppingElementsService } from '../../../core/services/shopping-elements.service';
import { InventariosService } from '../../../core/services/inventarios.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contenedor-detalle',
  templateUrl: './contenedor-detalle.component.html',
  styleUrls: ['./contenedor-detalle.component.css']
})
export class ContenedorDetalleComponent implements OnInit {
  idContainer: number;

  containerDetails: ContenedorDetail;

  loading: boolean;

  rootBreadcumb: string;
  childBreadcumb: string;

  isDocoutUser: boolean;

  isInLocationTab = false;
  isInDocumentalUnitsTab = false;

  existContainer = true;

  userIsPermissionPartialLoan: boolean;
  userIsPermissionLoan: boolean;

  private isModalEdit: boolean;
  private obsPartial = '';

  constructor(private activatedRoute: ActivatedRoute,
    private almacenService: AlmacenService,
    private authService: AuthenticationService,
    private seriesService: SeriesService,
    private modalService: BsModalService,
    private shoppingElementsService: ShoppingElementsService,
    private inventoryService: InventariosService,
    private toastr: ToastrService,
    private translateService: TranslateService) {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      const id = params.get('id');
      if (id && id != '') {
        this.idContainer = parseInt(id, 10);
        this.getContainerDetails();
        return;
      }
    });
  }

  ngOnInit() {
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
      });

    this.authService.getClienteName$().subscribe(rootBreadcumb => {
      this.rootBreadcumb = rootBreadcumb;
    });

    this.userIsPermissionPartialLoan = this.authService.permisosPartialLoan;
    this.userIsPermissionLoan = this.authService.permisosPrestamoContenedor;
  }

  volverSolicitud() {
    this.inventoryService.returnToSolicitud();
  }

  private getContainerDetails() {
    this.loading = true;
    this.almacenService.getContainerDetails(this.idContainer)
      .subscribe((details: ContenedorDetail) => {
        let containerDetail;
        if (details.canMakeOperations) {
          containerDetail = this.shoppingElementsService.getRecordWithCartInformation(details);
        } else {
          containerDetail = details;
        }
        this.containerDetails = containerDetail as ContenedorDetail;
        if (this.inventoryService.isCalledFromConsultas &&
          this.inventoryService.listInventory.filter(p => p == this.containerDetails.id.toString()).length > 0) {
          const shopCart = new ShoppingCart();
          shopCart.type = TypeShoppingCart.LOAN;
          this.containerDetails.shoppingCart = shopCart;
        }
        this.loading = false;
      },
        error => {
          this.loading = false;
          this.existContainer = false;
        });
  }

  openObsPartialModal() {
    this.isModalEdit = false;
    this.showModalText();
  }

  private showModalText() {
    const modalTitle = !this.isModalEdit ? 'inventory.tittleObsPartial' : 'inventory.tittleEditObsPartial';
    const modalTextConfirm = !this.isModalEdit ? 'inventory.createPartialLoan' : 'inventory.editPartialLoanButton';
    const modal = this.modalService.show(ModalShowTextComponent);
    (<ModalShowTextComponent>modal.content).showTextModal(
      modalTitle,
      this.obsPartial,
      modalTextConfirm
    );
    (<ModalShowTextComponent>modal.content).onClose.subscribe((result: string) => {
      if (result && result != '') {
        this.obsPartial = result;
        this.createPartialLoan();
      }
      this.closeModal();
    });
  }

  closeModal() {
    this.obsPartial = undefined;
    this.isModalEdit = false;
  }

  createPartialLoan() {
    if (this.inventoryService.isCalledFromConsultas()) {
      this.crearConsulta(this.containerDetails, true, this.obsPartial);
    } else {
      const containerDetails: InventoryIdenty = this.shoppingElementsService
        .addOrReplacePartialLoanElement(this.containerDetails, this.obsPartial);
      this.containerDetails.shoppingCart = containerDetails.shoppingCart;
    }
    this.closeModal();
  }

  private crearConsulta(unidadDocumental, parcial, textoParcial) {
    this.loading = true;
    this.inventoryService.addDocumentoConsulta(unidadDocumental, parcial, textoParcial)
      .subscribe(
        (r: ResponseAddRelacionContenidoUnidadDocumental) => {
          if (!r.isOk) {
            this.toastr.error(this.translateService.instant('consultas.consultanoguardadacontenedor'));
          } else {
            this.toastr.success(this.translateService.instant('consultas.consultaguardadacontenedor'));
          }
          this.loading = false;
        },
        () => {
          this.toastr.error(this.translateService.instant('consultas.errorguardarconsultacontenedor'));
          this.loading = false;
        }
      );
  }

  createLoan() {
    if (this.inventoryService.isCalledFromConsultas()) {
      this.crearConsulta(this.containerDetails, false, null);
    } else {
      const containerDetails: InventoryIdenty = this.shoppingElementsService.addOrReplaceLoanElement(this.containerDetails);
      this.containerDetails.shoppingCart = containerDetails.shoppingCart;
    }
  }

  containsContainerState(state: string): boolean {
    if (!this.containerDetails || !this.containerDetails.estado) {
      return false;
    }

    return this.containerDetails.estado.toString() === state;
  }

}


